module.exports = [
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost bojleru L",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Mono (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti L pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti L pre okamžitú vriacu vodu. Matný povrch z antikorovej ocele. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti L pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31543DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31543DC0/640/31543DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout starter kit with pull-out mousseur",
		"textblock_1st_text": "31543DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel U-spout with pull-out spray head, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31543DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31543000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31543000/640/31543000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout starter kit with pull-out mousseur",
		"textblock_1st_text": "31543000",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu, podpora Bluetooth® a Wi-Fi*. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena U s vyťahovacou sprchou, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31543000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31541DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31541DC0/640/31541DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s vytahovacím perlátorem, výpusť ve tvaru C",
		"textblock_1st_text": "31541DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel C-spout with pull-out spray head, stainless steel-look",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31541DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31541000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31541000/640/31541000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s vytahovacím perlátorem, výpusť ve tvaru C",
		"textblock_1st_text": "31541000",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu, podpora Bluetooth® a Wi-Fi*. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena C s vyťahovacou sprchou, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31541000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31539DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31539DC0/640/31539DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s vytahovacím perlátorem, výpusť ve tvaru L",
		"textblock_1st_text": "31539DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel L-spout with pull-out spray head, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31539DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC1/640/31456DC1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru U",
		"textblock_1st_text": "31456DC1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel U-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31456DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456001/640/31456001.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru U",
		"textblock_1st_text": "31456001",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu, podpora Bluetooth® a Wi-Fi*. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena U, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31456001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC1/640/31455DC1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455DC1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel C-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31455DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455001/640/31455001.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455001",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu, podpora Bluetooth® a Wi-Fi*. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena C, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31455001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC1/640/31454DC1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454DC1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel L-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31454DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454001/640/31454001.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454001",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu, podpora Bluetooth® a Wi-Fi*. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena L, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31454001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339DC1/640/30339DC1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost M",
		"textblock_1st_text": "30339DC1",
		"textblock_2nd_text": "No value for EndUserShort",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30339DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DL1/640/31498DL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada Mono s výpustí ve tvaru C",
		"textblock_1st_text": "31498DL1",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Mono: stojánková baterie v barvě kartáčovaný Warm Sunset pro filtrovanou, chlazenou a perlivou vodu, podpora Bluetooth a WiFi*, vysoká výpusť ve tvaru písmene C. Včetně chladiče, filtru a CO2 karbonizační lahve. 31498DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31498DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498AL1/640/31498AL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada Mono s výpustí ve tvaru C",
		"textblock_1st_text": "31498AL1",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Mono: stojánková baterie v barvě kartáčovaný Hard Graphite pro filtrovanou, chlazenou a perlivou vodu, podpora Bluetooth a WiFi*, vysoká výpusť ve tvaru písmene C. Včetně chladiče, filtru a CO2 karbonizační lahve. 31498AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31498AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DL1/640/31455DL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455DL1",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: kuchyňská baterie v barvě kartáčovaný Warm Sunset pro filtrovanou, chlazenou a perlivou vodu, podpora Bluetooth a WiFi*, vysoká výpusť ve tvaru písmene C. Včetně chladiče, filtru a CO2 karbonizační lahve. 31455DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31455DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455AL1/640/31455AL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455AL1",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: kuchyňská baterie v barvě kartáčovaný Hard Graphite pro filtrovanou, chlazenou a perlivou vodu, podpora Bluetooth a WiFi*, vysoká výpusť ve tvaru písmene C. Včetně chladiče, filtru a CO2 karbonizační lahve. 31455AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31455AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DL1/640/31454DL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454DL1",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: kuchyňská baterie v barvě kartáčovaný Warm Sunset pro filtrovanou, chlazenou a perlivou vodu, podpora Bluetooth a WiFi*, vysoká výpusť ve tvaru písmene L. Včetně chladiče, filtru a CO2 karbonizační lahve. 31454DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31454DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DL1/640/30327DL1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327DL1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo s vysokou výpustí ve tvaru písmene L a povrchovou úpravou kartáčovaný Warm Sunset. Obsahuje filtrační sadu a bojler velikosti M pro vařící vodu bez čekání. Energetická efektivita třídy A a bezpečnostní technologie. 30327DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30327DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454AL1/640/31454AL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454AL1",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: kuchyňská baterie v barvě kartáčovaný Hard Graphite pro filtrovanou, chlazenou a perlivou vodu, podpora Bluetooth a WiFi*, vysoká výpusť ve tvaru písmene L. Včetně chladiče, filtru a CO2 karbonizační lahve. 31454AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31454AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085DC1/640/30085DC1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost M",
		"textblock_1st_text": "30085DC1",
		"textblock_2nd_text": "No value for EndUserShort",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30085DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost M",
		"textblock_1st_text": "30339001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Mono (výpust v tvare písmena L) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Směšovací ventil",
		"textblock_1st_text": "40841001",
		"textblock_2nd_text": "No value for EndUserShort",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085AL1/640/30085AL1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost M",
		"textblock_1st_text": "30085AL1",
		"textblock_2nd_text": "Stojánková baterie GROHE RED Mono s vysokou výpustí ve tvaru písmene C a povrchovou úpravou kartáčovaný Hard Graphite. Obsahuje filtrační sadu a bojler velikosti M pro vařící vodu bez čekání. Energetická efektivita třídy A a bezpečnostní technologie. 30085AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30085AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DL1/640/30083DL1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083DL1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo s vysokou výpustí ve tvaru písmene C a povrchovou úpravou kartáčovaný Warm Sunset. Obsahuje filtrační sadu a bojler velikosti M pro vařící vodu bez čekání. Energetická efektivita třídy A a bezpečnostní technologie. 30083DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30083DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083AL1/640/30083AL1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083AL1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo s vysokou výpustí ve tvaru písmene C a povrchovou úpravou kartáčovaný Hard Graphite. Obsahuje filtrační sadu a bojler velikosti M pro vařící vodu bez čekání. Energetická efektivita třídy A a bezpečnostní technologie. 30083AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30083AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327AL1/640/30327AL1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327AL1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo s vysokou výpustí ve tvaru písmene L a povrchovou úpravou kartáčovaný Hard Graphite. Obsahuje filtrační sadu a bojler velikosti M pro vařící vodu bez čekání. Energetická efektivita třídy A a bezpečnostní technologie. 30327AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30327AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085DL1/640/30085DL1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost M",
		"textblock_1st_text": "30085DL1",
		"textblock_2nd_text": "Stojánková baterie GROHE RED Mono s vysokou výpustí ve tvaru písmene C a povrchovou úpravou kartáčovaný Warm Sunset. Obsahuje filtrační sadu a bojler velikosti M pro vařící vodu bez čekání. Energetická efektivita třídy A a bezpečnostní technologie. 30085DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30085DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC1/640/31498DC1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada Mono s výpustí ve tvaru C",
		"textblock_1st_text": "31498DC1",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: single-lever pillar tap for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel C-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31498DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498001/640/31498001.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada Mono s výpustí ve tvaru C",
		"textblock_1st_text": "31498001",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Mini: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu, podpora Bluetooth® a Wi-Fi*. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena C, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31498001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena L) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Matný povrch z antikorovej ocele. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena L) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena L) s filtračnou súpravou a bojlerom veľkosti L pre okamžitú vriacu vodu. Matný povrch z antikorovej ocele. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler, velikost L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena L) s filtračnou súpravou a bojlerom veľkosti L pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Výpusť ve tvaru písmene C, velikost M",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Mono (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Matný povrch z antikorovej ocele. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "Kuchynská batéria GROHE RED Duo (výpust v tvare písmena C) s filtračnou súpravou a bojlerom veľkosti M pre okamžitú vriacu vodu. Chrómový povrch. Energetická efektivita triedy A a bezpečnostné technológie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31539000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31539000/640/31539000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s vytahovacím perlátorem, výpusť ve tvaru L",
		"textblock_1st_text": "31539000",
		"textblock_2nd_text": "Úvodná súprava GROHE Blue Home Duo: páková kuchynská batéria pre filtrovanú, chladenú a perlivú vodu, podpora Bluetooth® a Wi-Fi*. Vrátane chladiča, filtra a CO2 karbonizačnej fľaše. Vysoký výpust v tvare písmena L s vyťahovacou sprchou, chrómový povrch.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31539000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083KS1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083KS1/640/30083KS1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30083KS1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene C) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Sametově černá povrchová úprava. Energetická efektivita třídy A a bezpečnostní technologie. 30083KS1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30083KS1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455KS1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455KS1/640/31455KS1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru C",
		"textblock_1st_text": "31455KS1",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu, podpora Bluetooth® a WiFi*. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoký otočný C-výtok, sametově černá povrchová úprava. 31455KS1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31455KS1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454KS1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454KS1/640/31454KS1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Startovní sada s výpustí ve tvaru L",
		"textblock_1st_text": "31454KS1",
		"textblock_2nd_text": "Úvodní sada GROHE Blue Home Duo: páková kuchyňská baterie pro filtrovanou, chlazenou a perlivou vodu, podpora Bluetooth® a WiFi*. Včetně chladiče, filtru a CO2 karbonizační lahve. Vysoký otočný L-výtok, sametově černý povrch. 31454KS1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/31454KS1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327KS1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327KS1/640/30327KS1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Výpusť a bojler velikosti M",
		"textblock_1st_text": "30327KS1",
		"textblock_2nd_text": "Kuchyňská baterie GROHE RED Duo (výpusť ve tvaru písmene L) s filtrační sadou a bojlerem velikosti M pro okamžitou vařící vodu. Sametově černá povrchová úprava. Energetická efektivita třídy A a bezpečnostní technologie. 30327KS1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.sk/sk_sk/product/30327KS1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.sk/sk_sk/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_sk_sk.json
// module id = 894
// module chunks = 0